import { render, staticRenderFns } from "./ProjectArchives.vue?vue&type=template&id=f0d8f8b2&scoped=true&"
import script from "./ProjectArchives.vue?vue&type=script&lang=js&"
export * from "./ProjectArchives.vue?vue&type=script&lang=js&"
import style0 from "./ProjectArchives.vue?vue&type=style&index=0&id=f0d8f8b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d8f8b2",
  null
  
)

export default component.exports